import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
			<p class="mb-3">
				
			</p>
			<p class="mb-3">
				<b>Н.Г.:</b> Вы – неизвестный автор, которого никто не читает. Как так получилось? 
			</p>
			
			<p class="mb-3">
				<b>Т.А.:</b> Я – неизвестный автор, которого никто не читает, не печатает и не публикует. 
				Наверное, мои мысли настолько не совпадают с общепринятыми, что просто не достигают мозга среднего человека, не могут быть восприняты им. 
				Сознание отдельной личности – это всегда какой-то определённый объём, заполненный определённым содержимым. 
				Мы заполняем мозг идеями, как желудок – пищей. 
				И как желудок переваривает пищу, так же и мозг переваривает идеи; и там, и там что-то остаётся и питает личность, а что-то уходит в отбросы.
			</p>
			
			<p class="mb-3">
				Но человек употребляет в пищу только съедобные или условно съедобные продукты; однако есть и такие, что  являются для человека ядовитыми и убивают его. 
				Это происходит или по ошибке и незнанию, когда употребляются в пищу незнакомые или похожие на знакомые грибы, ягоды, некоторые животные. 
				Или же намеренно, когда человек желает или вынужден самоубиться (как, например, Сократ). 
				Но практически не бывает случаев, когда человек ест то, что вообще не предназначено для еды: напр., цемент, воск, пепел… 
				Всё это тоже приводит к смерти; и те, кто это делает – обычно сумасшедшие, люди с изменённым, другим созанием. 
				Они не живут в мире людей, не повинуются их законам; и, естественно, это вытесняет их из мира людей в их собственный мир, иной в том и в другом смысле. 
			</p>
			
			<p class="mb-3">
				То же происходит и в головах: у простого человека есть определённая совокупность доступных, «съедобных» идей, 
				и всё другое так же отторгается организмом как несъедобное, невозможное к употреблению. 
				Как не придёт в голову есть песок или вату, так в ту же голову не могут прийти мысли, не основанные на органической, земной, привычной картине мира. 
				Просто для них места в обычном мозгу нет. 
			</p>
			
			<p class="mb-3">
				Но есть люди, вырывающиеся из этого круга, разрывающие эту оболочку, ограничивающую их мысли. 
				Они поднимаются на новую ступень, проникают в другой мир; или, точнее, расширяют границы нашего мира. 
				И рассказывают нам о нём, показывают нам его. 
				Разумеется, большинство из них, отравившись несъедобным, погибают: тоже становятся сумасшедшими – полный параллелизм деятельности мозга и желудка! – 
				или возглавляют великие религиозные (пророк Мухаммед) или прочие перевороты. 
			</p>
			
			<p class="mb-3">
				Но если в них не горит огонь насилия, если их привлекает жизнь мысли, расширение сознания, - то они становятся Творцами. 
				Не философами – их голые мысли остаются голыми мыслями, всего лишь прочерченными путями, - но кому нужен путь, по которому никто не идёт? 
				Направление становится живым, когда оно наполняется жизнью; когда за философами идут поэты, писатели, художники, композиторы…
			</p>
			
			<p class="mb-3">
				В наше время это Станислав Лем, раскрывший иные законы и понятия о существовании: «Среди звёзд нас ждёт Неведомое»). 
				Это автор песен Михаил Щербаков, соединённым воздействием слов и музыки выводящий нас в совсем другие места, ещё не освоенные нашим сознанием. 
				Это композитор Александр Скрябин, писатель Герман Гессе…
			</p>
			
			<p class="mb-3">
				А сколько же мелких, не дотягивающих до уровня гениев, но тоже чувствующих «что-то» и пытающихся это выразить в меру своих сил! 
				Но и сил маловато, и гибнуть суждено многим на этом пути, во тьме, среди камней и обвалов, следуя лишь еле видимой траектории высоко в небе. 
				Путь наощупь, в ночи. 
				Но есть направление, и идут люди, ломая ноги, но подняв голову к тому, что указывает дорогу наверху. 
			</p>
			
			<p class="mb-3">
				Вот и я – один из этих идущих. 
			</p>
			
		</div>
    `
  )
}

const itemName = {
  rus: `Отрывок из интервью Т.А. несуществующей газете`
}

const itemDate = {
	rus: "28 декабря 2024 г."
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
		itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;

